import { useEffect, useRef, useState, type KeyboardEvent } from 'react'
import { Icon } from './Icon'

/** A compact record action, separate from the full-size controls used to fill out a form. */
export function StatusMenu({value,options,onChange,label}: {value:string;options:readonly {key:string;label:string}[];onChange:(value:string)=>Promise<void>;label:string}) {
  const [open,setOpen]=useState(false)
  const [busy,setBusy]=useState(false)
  const root=useRef<HTMLDivElement>(null)
  const trigger=useRef<HTMLButtonElement>(null)
  const current=options.find(o=>o.key===value)
  const close=()=>{setOpen(false);trigger.current?.focus()}
  useEffect(()=>{
    if(!open)return
    const outside=(e:MouseEvent)=>{if(!root.current?.contains(e.target as Node))setOpen(false)}
    document.addEventListener('mousedown',outside)
    requestAnimationFrame(()=>root.current?.querySelector<HTMLElement>('[aria-checked="true"]')?.focus())
    return ()=>document.removeEventListener('mousedown',outside)
  },[open])
  const keys=(e:KeyboardEvent)=>{
    if(e.key==='Escape' && open){e.preventDefault();e.stopPropagation();close()}
    if(e.key==='Tab')setOpen(false)
    if(!['ArrowDown','ArrowUp','Home','End'].includes(e.key))return
    e.preventDefault()
    if(!open){setOpen(true);return}
    const items=Array.from(root.current?.querySelectorAll<HTMLButtonElement>('[role="menuitemradio"]')??[])
    const i=items.indexOf(document.activeElement as HTMLButtonElement)
    const next=e.key==='Home'?0:e.key==='End'?items.length-1:e.key==='ArrowDown'?(i+1)%items.length:(i-1+items.length)%items.length
    items[next]?.focus()
  }
  return <div className="record-status" ref={root} onKeyDown={keys}>
    <button className="record-status-trigger" type="button" aria-label={`${label}: ${current?.label ?? value}`} aria-haspopup="menu" aria-expanded={open} disabled={busy} aria-busy={busy} onClick={()=>setOpen(!open)}><span className="record-status-dot"/>{busy?'Updating…':current?.label??value}<Icon name="expand_more" size={15}/></button>
    {open?<div className="record-status-menu" role="menu" aria-label={label}><span className="record-status-caption">Change stage</span>{options.map(o=><button key={o.key} type="button" role="menuitemradio" aria-checked={o.key===value} tabIndex={-1} onClick={async()=>{close();if(o.key===value)return;setBusy(true);try{await onChange(o.key)}finally{setBusy(false);requestAnimationFrame(()=>trigger.current?.focus())}}}><span>{o.label}</span>{o.key===value?<Icon name="check" size={16}/>:null}</button>)}</div>:null}
  </div>
}
